import {
  createFileRoute,
  useNavigate,
  useParams,
} from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { TitleWithQuestion } from '@/common/TitleWithQuestion';
import { WBSButton } from '@/common/WBSButton';
import { CongregationCampaignTable } from '@/tables/CongregationCampaignTable';
import { GroupHeaderWrapper } from '~/styles/layoutElements';

export const Route = createFileRoute(
  '/_app/_dashboard/groups/$groupName/campaign/',
)({
  component: CongregationCampaignScreen,
});

function CongregationCampaignScreen() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { groupName } = useParams({
    from: '/_app/_dashboard/groups/$groupName/campaign/',
  });

  return (
    <>
      <GroupHeaderWrapper>
        <TitleWithQuestion title={t('sidebar.campaigns')} />
        <WBSButton
          wide
          onClick={() =>
            navigate({
              to: '/groups/$groupName/campaign/add/',
              params: { groupName },
            })
          }
        >
          {t('actions.add-new-campaign')}
        </WBSButton>
      </GroupHeaderWrapper>
      <CongregationCampaignTable />
    </>
  );
}
